import firebase from '../../lib/firebase.prod';
import * as PROJECT_CODE from '../../constants/projectCode';
import dayjs from 'dayjs';

const firebaseRef = firebase.database();

export function getAgendaData(userType, setSchedulerData) {
	var currentUserId = firebase.auth().currentUser.uid;

	var appointmentsRef = firebaseRef.ref(
		'/client_appointments/' + PROJECT_CODE.projectCode
	);
	appointmentsRef
		.orderByChild('createrID')
		.equalTo(currentUserId)
		.on('value', (snapshot) => {
			var appointments = [];
			var appCode;
			snapshot.forEach((element) => {
				var elementTime = element.val().timeOfAppointment;
				var elementTime30minAfter = elementTime + 1800000;
				var timeFormat = new Date(elementTime);
				var endTimeFormat = new Date(elementTime30minAfter);
				var usersRef = element.child('users');
				var fullName;
				var userEmail;
				var userPhone;
				var notes;
				var appName = element.val().appointmentName;
				appCode = element.val().appointmentID;
				var currentUserId = firebase.auth().currentUser.uid;
				var shortcode = element.val().shortCode;

				console.log('shortcode: ' + shortcode);

				fullName = usersRef.val()['0'].fullName;
				userEmail = usersRef.val()['0'].email;
				userPhone = usersRef.val()['0'].phoneNumber;
				notes = usersRef.val()['0'].notes;

				var timeFormatBuild =
					dayjs(timeFormat).format('YYYY-MM-DDTHH:mm');

				var endTimeFormatBuild =
					dayjs(endTimeFormat).format('YYYY-MM-DDTHH:mm');

				var scheduleData = {
					startDate: timeFormatBuild,
					endDate: endTimeFormatBuild,
					title: `Meeting with ${fullName}`,
					fullName: fullName,
					email: userEmail,
					notes: notes,
					phoneNumber: userPhone,
					appTime: elementTime,
					appName: appName,
					appCode: appCode,
					currentUserId: currentUserId,
					currentUserType: userType,
					shortcode: shortcode,
				};

				console.log(JSON.stringify(scheduleData));

				console.log('These are the times: ', timeFormatBuild);
				appointments.push(scheduleData);
			});
			console.log('These are the appts: ', appointments);

			var newAppointments = appointments.filter(
				(item) =>
					!item.title.includes('Meeting with null') &&
					!item.title.includes('Meeting with undefined')
			);

			setSchedulerData(newAppointments);
		});
}

export function rescheduleAppointment(
	appointmentId,
	time,
	setLoading,
	displayAlert
) {
	setLoading && setLoading(true);
	let appointmentsRef = firebaseRef.ref(
		'/client_appointments/' + PROJECT_CODE.projectCode
	);
	appointmentsRef.once('value', (snapshot) => {
		let appointmentParent = snapshot.val();
		if (appointmentParent) {
			let appointmentKeys = Object.keys(appointmentParent);

			if (appointmentKeys.includes(appointmentId)) {
				firebaseRef
					.ref(
						'/client_appointments/' +
							PROJECT_CODE.projectCode +
							'/' +
							appointmentId
					)
					.update(
						{
							timeOfAppointment: time,
						},
						(error) => {
							if (error) {
								displayAlert &&
									displayAlert(
										'Fail to reschedule the appointment.',
										'error'
									);
								setLoading && setLoading(false);
							} else {
								let users =
									appointmentParent[appointmentId].users;
								if (
									users['0'] !== null &&
									users['0'] !== undefined
								) {
									let userEmailPush = firebaseRef
										.ref('/client_emails')
										.child(PROJECT_CODE.projectCode)
										.push();
									users['0']['appointmentID'] = appointmentId;
									userEmailPush.set(users['0']);
								}
								if (
									users['1'] !== null &&
									users['1'] !== undefined
								) {
									let userEmailPush1 = firebaseRef
										.ref('/client_emails')
										.child(PROJECT_CODE.projectCode)
										.push();
									users['1']['appointmentID'] = appointmentId;
									userEmailPush1.set(users['1']);
								}
								if (
									users['2'] !== null &&
									users['2'] !== undefined
								) {
									let userEmailPush2 = firebaseRef
										.ref('/client_emails')
										.child(PROJECT_CODE.projectCode)
										.push();
									users['2']['appointmentID'] = appointmentId;
									userEmailPush2.set(users['2']);
								}
								displayAlert &&
									displayAlert(
										'Reschedule the appointment successfully.',
										'success'
									);
								setLoading && setLoading(false);
							}
						}
					);
			} else {
				displayAlert &&
					displayAlert(
						'1 Fail to reschedule the appointment.',
						'error'
					);
				setLoading && setLoading(false);
			}
		} else {
			displayAlert &&
				displayAlert('2 Fail to reschedule the appointment.', 'error');
			setLoading && setLoading(false);
		}
	});
}

export function cancelAppointment(deleteKey, setAlert) {
	if (deleteKey) {
		var newDeleteRef = firebase
			.database()
			.ref('/client_appointments/' + PROJECT_CODE.projectCode)
			.child(deleteKey);

		let appointmentInfo;
		newDeleteRef.once('value', (snapshot) => {
			appointmentInfo = snapshot.val();
		});
		newDeleteRef
			.remove()
			.then(() => {
				let users = appointmentInfo.users;
				if (users['0'] !== null && users['0'] !== undefined) {
					let userEmailDeletePush = firebase
						.database()
						.ref('/client_delete_emails')
						.child(PROJECT_CODE.projectCode)
						.push();
					let userEmailDeleteInfo = {
						adminUser: users['0'].email,
						email: users['0'].email,
						timeOfAppointment: appointmentInfo.timeOfAppointment,
					};
					userEmailDeletePush.set(userEmailDeleteInfo);
				}
				if (users['1'] !== null && users['1'] !== undefined) {
					let userEmailDeletePush = firebase
						.database()
						.ref('/client_delete_emails')
						.child(PROJECT_CODE.projectCode)
						.push();
					let userEmailDeleteInfo = {
						adminUser: users['1'].email,
						email: users['1'].email,
						timeOfAppointment: appointmentInfo.timeOfAppointment,
					};
					userEmailDeletePush.set(userEmailDeleteInfo);
				}
				if (users['2'] !== null && users['2'] !== undefined) {
					let userEmailDeletePush = firebase
						.database()
						.ref('/client_delete_emails')
						.child(PROJECT_CODE.projectCode)
						.push();
					let userEmailDeleteInfo = {
						adminUser: users['2'].email,
						email: users['2'].email,
						timeOfAppointment: appointmentInfo.timeOfAppointment,
					};
					userEmailDeletePush.set(userEmailDeleteInfo);
				}

				if (
					appointmentInfo.leadId &&
					appointmentInfo.leadToSalesAgent
				) {
					let leadId = appointmentInfo.leadId;
					let salesAgentId = appointmentInfo.leadToSalesAgent;
					let leadRef;
					let checkRef;
					let checkRef2;

					firebase
						.database()
						.ref(
							'/kavtek_leads/' +
								PROJECT_CODE.projectCode +
								'/' +
								leadId
						)
						.once('value', (snapshot) => {
							checkRef = snapshot.val();
						});

					firebase
						.database()
						.ref(
							'/kavtek_purchasers/' +
								PROJECT_CODE.projectCode +
								'/' +
								salesAgentId +
								'/' +
								leadId
						)
						.once('value', (snapshot) => {
							checkRef2 = snapshot.val();
						});
					if (checkRef) {
						leadRef = firebase
							.database()
							.ref(
								'/kavtek_leads/' +
									PROJECT_CODE.projectCode +
									'/' +
									leadId
							);
						leadRef.update({
							sentEmail: false,
						});
					} else if (checkRef2) {
						leadRef = firebase
							.database()
							.ref(
								'/kavtek_purchasers/' +
									PROJECT_CODE.projectCode +
									'/' +
									salesAgentId +
									'/' +
									leadId
							);
						leadRef.update({
							sentEmail: false,
						});
					}
				}
			})
			.then(() => {
				setAlert('Meeting is canceled successfully');
			})
			.catch((err) => {
				console.log('Cancel meeting error: ', err);
			});
	}
}
